<template>
  <div id="CallHistoryList">
    <div>
      <a-row>
        <a-col :span="12">
          <div class="text-red-center">
            注意事项：<br />
            最新支付订单数据一小时更新一次<br />
            通话数据实时更新<br />
            <a-range-picker @change="onChange" />
          </div>
        </a-col>
        <a-col :span="12">
          <div id="report" class="col-md-6 text-center">
            总通话数量：{{ allcount }} = 无效:有效（{{ notvalid }}/{{
              valid
            }})<br />
            接听率：{{ (valid / allcount) | toPercent }}<br />
            最长通话时长：{{ maxDurtion | stom }} <br />
            平均通话时长：{{ avgDurtion | stom }}<br />
            总通话时长：{{ countDurtion | stom }}<br />
            当天呼叫后购买：{{ this.buyTimeAfterCallTime }}单(仅供参考)
          </div>
        </a-col>
      </a-row>
    </div>
    <div style="margin-top: 30px">
      <a-table
        :columns="callHistoryColumns"
        :rowKey="(record) => record.ID"
        :dataSource="tableData"
        bordered
        size="small"
        :pageSize="pageSize"
        :pagination="pagination"
      >
        <div slot="Starttimecaller" slot-scope="text">
          {{ text | timeFormat }}
        </div>
        <div
          slot="lastOrder"
          slot-scope="text, record"
          @click="showLastOrderInfoModal(record.Qkidscrmid)"
        >
          <template v-if="showLastProductName(record.productid)">
            <template
              v-if="paidTimeRed(record.Starttimecaller, record.paidtime)"
            >
              <a style="color: red"
                >{{ text }}({{ record.paidtime | timeFormat }})</a
              >
            </template>
            <template v-else>
              <a>{{ text }}({{ record.paidtime | timeFormat }})</a>
            </template>
          </template>
          <template v-else>
            <a>-</a>
          </template>
        </div>
        <a
          slot="crmID"
          slot-scope="text, record"
          @click="showCallHistoryModel(record.Qkidscrmid)"
          >{{ text }}</a
        >
        <a
          slot="telB"
          slot-scope="text, record"
          @click="showCallHistoryModel(record.Qkidscrmid)"
          >{{ text | hidePhone }}</a
        >
        <div slot="duration" slot-scope="text">{{ text | stom }}</div>
        <div slot="recordUrl" slot-scope="text, record">
          <template v-if="isShowRecordUrl(record.recordUrl)">
            <a
              v-on:click="playAudioURL(record.ID)"
              :id="setAudioBtnID(record.ID)"
              >播放</a
            >
            |
            <audio
              :src="record.recordUrl"
              :id="record.ID"
              @ended="audioEnded(record.ID)"
            >
              您的浏览器不支持audio
            </audio>
            <a :href="record.recordUrl">下载</a>
          </template>
          <template v-else> - </template>
        </div>
      </a-table>
    </div>
    <ModelBills :model-bills-crmid="this.selectModelBillsCrmID" />
    <ModelCallHistory :model-call-history-crmid="this.selectCallHistoryCrmid" />
  </div>
</template>

<script>
import { GetHistoryCallRecordsWithDateTime, DoubleCallWithPhone } from '@/api/QkidsApi.js'
import ModelBills from '@/views/components/models/ModelBills.vue'
import ModelCallHistory from '@/views/components/models/ModelCallHistory.vue'
import Message from 'ant-design-vue/lib/message'

const callHistoryColumns = [
  { title: '发起时间', dataIndex: 'Starttimecaller', key: 'Starttimecaller', scopedSlots: { customRender: 'Starttimecaller' } },
  { title: '最新支付订单', dataIndex: 'proname', key: 'lastOrder', scopedSlots: { customRender: 'lastOrder' } },
  { title: '学生 ID', dataIndex: 'Qkidscrmid', key: 'crmid', scopedSlots: { customRender: 'crmID' } },
  { title: '呼叫手机号', dataIndex: 'telB', key: 'telB', scopedSlots: { customRender: 'telB' } },
  { title: '通话时长', dataIndex: 'duration', key: 'duration', scopedSlots: { customRender: 'duration' } },
  { title: '录音管理', dataIndex: 'recordUrl', key: 'recordUrl', scopedSlots: { customRender: 'recordUrl' } }
]

export default {
  name: 'CallHistoryList',
  data () {
    return {
      allcount: 0,
      notvalid: 0,
      valid: 0,
      avgDurtion: 0,
      countDurtion: 0,
      maxDurtion: 0,
      callHistoryColumns,
      tableData: [],
      buyTimeAfterCallTime: 0,
      buyCrmIDArr: [],
      tableProductBillsData: [],
      ModalText: '123',
      pageSize: 100,
      selectModelBillsCrmID: 0,
      selectCallHistoryCrmid: 0,
      dateStart: '',
      dateEnd: '',
      pagination: {
        defaultPageSize: 15,
        showTotal: total => `共 ${total} 条数据`,
        showSizeChanger: true,
        pageSizeOptions: ['15', '30', '50']
      }
    }
  },
  components: {
    ModelBills,
    ModelCallHistory
  },
  props: ['selectPersonId'],
  methods: {
    closeModel (e) {
      this.modelCallHistoryVisible = false
    },
    showLastOrderInfoModal (selectCrmID) {
      this.selectModelBillsCrmID = parseInt(selectCrmID)
      this.$store.state.isShowBillsModel = true
    },
    showCallHistoryModel (crmid) {
      this.selectCallHistoryCrmid = parseInt(crmid)
      this.$store.state.isShowCallHistoryModel = true
    },
    showLastProductName (productid) {
      if (productid === '') {
        return false
      } else {
        return true
      }
    },
    getHistoryCallRecordsWithDateTime (pid, dateStart, dateEnd) {
      this.tableData = []
      this.allcount = 0
      this.countDurtion = 0
      this.valid = 0
      this.notvalid = 0
      this.avgDurtion = 0
      this.maxDurtion = 0
      this.buyTimeAfterCallTime = 0
      this.buyCrmIDArr = []
      GetHistoryCallRecordsWithDateTime(pid, dateStart, dateEnd)
        .then((req) => {
          this.tableData = req.data
          this.allcount = req.data.length
          req.data.forEach((item, index) => {
            var durationInt = parseInt(item.duration)
            if (this.paidTimeRed(item.Starttimecaller, item.paidtime)) {
              if (this.buyCrmIDArr.indexOf(item.Qkidscrmid) === -1) {
                this.buyTimeAfterCallTime += 1
                this.buyCrmIDArr.push(item.Qkidscrmid)
              }
            }
            if (durationInt === 0) {
              this.notvalid += 1
            } else {
              if (this.maxDurtion < durationInt) {
                this.maxDurtion = durationInt
              }
              this.valid++
              this.countDurtion += durationInt
            }
          })
          if (this.valid === 0) {
            this.avgDurtion = 0
          } else {
            this.avgDurtion = this.countDurtion / this.valid
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    onChange: function (date, dateString) {
      this.dateStart = dateString[0]
      this.dateEnd = dateString[1]
      console.log(this.selectPersonId, dateString)
      this.getHistoryCallRecordsWithDateTime(this.selectPersonId, this.dateStart, this.dateEnd)
    },
    isShowRecordUrl: (url) => {
      if (url === '') {
        return false
      } else {
        return true
      }
    },
    audioEnded: function (str) {
      var btn = document.getElementById('btn' + str)
      btn.innerHTML = '重新播放'
    },
    playAudioURL: function (str) {
      var audio = document.getElementById(str)
      var btn = document.getElementById('btn' + str)
      if (audio.paused) {
        audio.play()
        btn.innerHTML = '暂停'
      } else {
        audio.pause()
        btn.innerHTML = '继续播放'
      }
    },
    setAudioBtnID: function (str) {
      return 'btn' + str
    },
    paidTimeRed: function (paidTime, callTime) {
      paidTime = paidTime.replace('T', ' ').replace('+08:00', '')
      callTime = callTime.replace('T', ' ').replace('+08:00', '')
      if (callTime > paidTime) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    selectPersonId: function () {
      if (this.dateStart !== '' && this.dateEnd !== '') {
        this.getHistoryCallRecordsWithDateTime(this.selectPersonId, this.dateStart, this.dateEnd)
      }
    }
  },
  filters: {
    toPercent: (value) => {
      var str = Number(value * 100).toFixed(2)
      str += '%'
      return str
    },
    stom: (value) => {
      var secondTime = parseInt(value)
      var minuteTime = 0
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60)
        secondTime = parseInt(secondTime % 60)
      }
      var result = '' + parseInt(secondTime) + '秒'
      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + '分' + result
      }
      return result
    },
    timeFormat: (value) => {
      value = String(value).replace('T', ' ')
      value = String(value).replace('+08:00', '')
      return value
    },
    hidePhone: (phone) => {
      let newphone = String(phone).substr(0, 3) + '****' + String(phone).substr(7, 11)
      return newphone
    }
  }
}
</script>
<style scoped>
.text-red-center {
  color: red;
  text-align: center;
}
</style>
